/**
 * Created by Claude on 09.04.2026
 */

const LandmarkSelectWindow = CleverappsWindow.extend({
    onWindowLoaded: function (landmark) {
        this.initialLandmark = landmark;
        this.landmark = landmark;

        this.changeSelectedThrottled = cleverapps.throttle(300, this.createListener(this.changeSelected.bind(this)));
        this.changeBackgroundThrottled = cleverapps.throttle(300, this.createListener(this.changeBackground.bind(this)));

        const options = {
            styles: cleverapps.styles.LandmarkSelectWindow.window,
            title: Messages.get("AchievementWindow.title"),
            name: "AchievementWindow",
            content: this.createContent(),
            foreground: bundles.windows.frames.window_foreground_png
        };

        const landmarks = Map2dLocation.currentLocation.landmarks;
        if (landmark && landmark.unit && Map2d.currentMap) {
            options.contentPadding = Map2d.currentMap.isCloseToMapLeft(landmark.unit) ? cleverapps.UI.DOCK_RIGHT : cleverapps.UI.DOCK_LEFT;
        }
        if (landmarks) {
            options.help = () => {
                this.close();

                cleverapps.focusManager.display({
                    focus: "GuideWindow",
                    stack: true,
                    action: (f) => {
                        new GuideWindow(landmarks.getGuideWindowOptions());
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            };
        }

        this._super(options);

        this.updateItems();
    },

    onResize: function () {
        this._super();

        if (this.landmark && this.landmark.unit && Map2dScroller.currentScroller) {
            Map2dScroller.currentScroller.scrollToUnit(0, this.landmark.unit, {
                position: cleverapps.UI.DOCK_LEFT | cleverapps.UI.DOCK_RIGHT,
                padding: cleverapps.styles.LandmarkSelectWindow.scrollToUnitPadding
            });
        }
    },

    onClose: function () {
        if (this.initialLandmark && this.initialLandmark.stage !== this.landmark.stage) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.LANDMARKS.REPLACE + this.landmark.stage);
        }

        if (Map2d.currentMap) {
            Map2d.currentMap.unhighlightUnit();
        }
    },

    isSelectedLandmark: function (target) {
        if (!this.landmark || !this.landmark.unit) {
            return false;
        }
        return Unit.IsApplicable(target.config, this.landmark.unit);
    },

    createContent: function () {
        const bg = this.bg = new cc.Node();
        this.bg.setContentSize2(cleverapps.styles.LandmarkSelectWindow.grid);

        this.addScroll(this.createGrid());

        return bg;
    },

    addScroll: function (grid) {
        const scroll = this.scroll = new cleverapps.UI.ScrollView(grid, {
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL
        });
        scroll.setContentSize2(this.bg.width, this.bg.height);
        scroll.setAlignment(this.bg.width / 2, this.bg.height / 2);
        scroll.setBarPadding(cleverapps.styles.LandmarkSelectWindow.scrollBarPadding);
        this.bg.addChild(scroll);

        if (this.landmark instanceof Landmark) {
            scroll.scrollTo(this.availableUnits.find((unit) => this.isSelectedLandmark(unit)));
        } else {
            scroll.scrollToPercent(100);
        }
    },

    updateItems: function () {
        this.availableUnits.forEach((item) => {
            item.updateState();
        }, this);
    },

    createUnits: function () {
        const landmarks = Map2dLocation.currentLocation.landmarks;
        const availableLandmarks = landmarks.listWindowLandmarks(this.initialLandmark);
        return availableLandmarks.map((config) => new LandmarkSelectItem(config));
    },

    createGrid: function () {
        const styles = cleverapps.styles.LandmarkSelectWindow.grid;

        this.availableUnits = this.createUnits();

        const grid = this.grid = new cleverapps.GridLayout(this.availableUnits, {
            columns: 3,
            margin: styles.margin,
            padding: styles.padding
        });

        cleverapps.UI.onClick(grid, this.onClick.bind(this), {
            interactiveScale: false,
            onDoubleClick: cleverapps.config.debugMode && this.onDoubleClick.bind(this)
        });

        return grid;
    },

    findClickTarget: function (point) {
        return this.availableUnits.filter((node) => cc.rectContainsPoint(node.getBoundingBox(), point))[0];
    },

    onClick: function (touch) {
        const point = this.grid.convertTouchToNodeSpace(touch);
        const target = this.findClickTarget(point);
        if (target) {
            if (target.canDeploy()) {
                this.changeSelectedThrottled(target);
            } else if (target.canHint()) {
                target.findButtonClick();
            } else if (!this.isSelectedLandmark(target)) {
                this.swapLandmarks(target);
            }
        }
    },

    onDoubleClick: function (touch) {
        const point = this.grid.convertTouchToNodeSpace(touch);
        const target = this.findClickTarget(point);
        if (!target) {
            return;
        }

        const config = AchievementsConfig.findByUnit(target.config);
        if (!config) {
            return;
        }

        if (!cleverapps.achievements.isGathered(config.id)) {
            cleverapps.achievements.grant(config.id);
            this.changeSelectedThrottled(target);
            return;
        }

        cleverapps.achievements.revoke(config.id);

        const newChosen = this.availableUnits.find((unit) => unit.canDeploy()) || new LandmarkSelectItem({ code: "landmarkspot", stage: 0 });

        if (this.isSelectedLandmark(target)) {
            this.changeSelectedThrottled(newChosen);
        } else if (target.getDeployed()) {
            this.changeBackgroundThrottled(target, newChosen);
        } else {
            this.updateItems();
        }
    },

    swapLandmarks: function (target) {
        this.changeBackgroundThrottled(target, this.landmark);
        this.changeSelectedThrottled(target);
    },

    changeBackground: function (current, newLandmark) {
        const deployLocation = cc.p(current.getDeployed());
        Map2dLocation.currentLocation.landmarks.construct(newLandmark.unit, deployLocation);
        this.updateItems();
    },

    changeSelected: function (target) {
        this.landmark.unit = Map2dLocation.currentLocation.landmarks.construct(target.config, cc.p(this.landmark.unit));

        Map2dScroller.currentScroller.scrollToUnit(0.2, this.landmark.unit, {
            position: cleverapps.UI.DOCK_LEFT | cleverapps.UI.DOCK_RIGHT,
            padding: cleverapps.styles.LandmarkSelectWindow.scrollToUnitPadding,
            callback: () => {
                Map2d.currentMap.unhighlightUnit(() => {
                    if (!this.closed) {
                        Map2d.currentMap.highlightUnit(this.landmark.unit);
                    }
                });
            }
        });

        this.updateItems();
    },

    onHide: function () {
        this._super();

        Map2d.currentMap.unhighlightUnit();
    },

    listBundles: function () {
        const resultBundles = ["landmarkselectwindow"];
        const families = {};

        Map2dLocation.currentLocation.landmarks.listWindowLandmarks().forEach((landmark) => {
            families[landmark.code + landmark.stage] = landmark;
        });

        return resultBundles.concat(Families.listLazyBundles(Object.values(families)));
    }
});

cleverapps.styles.LandmarkSelectWindow = {
    sideOffset: 40,

    window: {
        padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10
        }
    },

    grid: {
        width: 900,
        height: 800,

        margin: {
            x: 30,
            y: 30
        },

        padding: {
            x: 15,
            y: 75
        }
    },
    scrollBarPadding: {
        sidePadding: 0
    },

    scrollToUnitPadding: {
        left: 120,
        right: 120
    }
};
